import React, { FC, useRef } from 'react';
import LocalModal from 'components/base/local-modal';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as DownloadTemplateIcon } from 'assets/icons/download-template.svg';

type InfoModalProps = {
  show: boolean;
  onClose: () => void;
  title: string;
  downloadLink: string;
  children: React.ReactNode;
  handleFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleFileChange?: () => void;
};

const CsvInfoModal: FC<InfoModalProps> = ({
  show,
  onClose,
  title,
  downloadLink,
  children,
  handleFileUpload,
  handleFileChange
}) => {
  const fileUploadRef = useRef<HTMLInputElement | null>(null);
  const handleConfirm = () => {
    if (fileUploadRef.current) {
      fileUploadRef.current.click();
      handleFileChange?.();
    }
  };

  const handleDownloadTemplate = () => {
    window.open(downloadLink, '_blank');
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={onClose}
      title={title}
      contentClassName='!max-w-[442px]'
      footer={
        <div className='flex gap-5 justify-end mt-8'>
          <Button
            onClick={handleDownloadTemplate}
            small
            variant='block'
            color='transparent'
            className='text-sm h-[41px]'>
            <DownloadTemplateIcon className='mx-1' />
            Download Template
          </Button>

          <Button
            onClick={handleConfirm}
            className='w-[139px] h-[41px] text-sm'
            color='primary'
            small
            variant='block'>
            Select
          </Button>
          <input
            ref={fileUploadRef}
            type='file'
            accept='.xlsx, .xls, .csv'
            hidden
            onChange={handleFileUpload}
          />
        </div>
      }>
      {children}
    </LocalModal>
  );
};

export default CsvInfoModal;
